import { Paper, Stack } from '@mui/material'
import { WeatherSunny20Regular, WeatherSunnyLow20Regular } from '@/components/Icon'
import appearanceStyles from '@/components/Settings/AppearanceSettingsContent.module.scss'
import { SettingsRowLabelBlock } from '@/components/Settings/settingsRowLabelBlock'
import SettingsSliderControl from '@/components/Settings/SettingsSliderControl'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import shared from '@/components/Settings/settingsShared.module.scss'

/** @param {{ headingId: string, paperSingle: string, brightness: number, onBrightnessChange: (v: number) => void }} props */
export function AppearanceBrightnessSection({ headingId, paperSingle, brightness, onBrightnessChange }) {
  return (
    <Stack component="section" spacing={1.25} className={shared.preferenceSection} aria-labelledby={headingId}>
      <SettingsSectionIntro headingId={headingId} lines={getSettingsSectionIntro('brightness')} />
      <Paper elevation={0} className={paperSingle}>
        <Stack spacing={1.25} className={appearanceStyles.appearanceRow}>
          <SettingsRowLabelBlock title="Brightness" hideDescription />
          <SettingsSliderControl value={brightness} onChange={onBrightnessChange} aria-label="Brightness" StartIcon={WeatherSunnyLow20Regular} EndIcon={WeatherSunny20Regular} />
        </Stack>
      </Paper>
    </Stack>
  )
}
